// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { useEffect, useState } from "react";
import { notify } from "@/shared/utils/notify";
import { useLocation, useNavigate } from 'react-router-dom';

import { setIsProductsForUpdate, setProductsForUpdate } from "../../../redux";
import useAppDispatch from "../../../redux/hooks/useAppDispatch";
import { productsService } from "../../../shared/services";
import { pendingProductMediaStore } from "../lib/pendingProductMediaStore";

export const useProductById = () => {
    const [isValidate, setIsValidate ] = useState(false)
    const { pathname } = useLocation()
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const getSingleProduct = async ( id: number) =>{
      return await productsService
      .get(id)
      .then((res) => {
        return res;
      })
      .catch((err: any) => {
        console.log(err);
        navigate(`/products`);
        notify.error(err.message);
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if( pathname !== "/products/new" ){
          if (isNaN(pathname.split("/")[2])) return navigate(`/products`);
            dispatch(setIsProductsForUpdate(true));
            getSingleProduct(Number(pathname.split("/")[2])).then((res) =>
                dispatch(setProductsForUpdate(res as any))
              );
            setIsValidate(true)
        }else if(pathname === "/products/new" ){
            pendingProductMediaStore.clear();
            dispatch(setIsProductsForUpdate(false));
            dispatch(setProductsForUpdate(undefined as any));
            setIsValidate(true)
        }
    }, [])
  return {
    //state
    isValidate
    //methods
    //functions
  }
}
